module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon14.c7a3e3cc.png";